"use strict";

exports.__esModule = true;
exports.sortTooltipItems = exports.TOOLTIP_SORT_OPTIONS = exports.TOOLTIP_SORT_DESC = exports.TOOLTIP_SORT_ASC = exports.TOOLTIP_SORT_ALPHA = void 0;
var TOOLTIP_SORT_DESC = exports.TOOLTIP_SORT_DESC = "desc";
var TOOLTIP_SORT_ASC = exports.TOOLTIP_SORT_ASC = "asc";
var TOOLTIP_SORT_ALPHA = exports.TOOLTIP_SORT_ALPHA = "alpha";
var TOOLTIP_SORT_OPTIONS = exports.TOOLTIP_SORT_OPTIONS = [{
  key: TOOLTIP_SORT_DESC,
  label: "Descending"
}, {
  key: TOOLTIP_SORT_ASC,
  label: "Ascending"
}, {
  key: TOOLTIP_SORT_ALPHA,
  label: "Alphabetical"
}];
var sortTooltipItems = exports.sortTooltipItems = function sortTooltipItems(items, details, tooltipSort) {
  if (details === void 0) {
    details = [];
  }
  if (tooltipSort === void 0) {
    tooltipSort = TOOLTIP_SORT_DESC;
  }
  var sorted = [].concat(items || []);
  if (tooltipSort === TOOLTIP_SORT_ALPHA) {
    var nameFor = function nameFor(item) {
      var detail = details.find(function (v) {
        return v.key === item.key;
      });
      return detail && detail.name || item.key || "";
    };
    return sorted.sort(function (a, b) {
      return nameFor(a).localeCompare(nameFor(b), undefined, {
        sensitivity: "base"
      });
    });
  }
  if (tooltipSort === TOOLTIP_SORT_ASC) {
    return sorted.sort(function (a, b) {
      return (a.duration || 0) - (b.duration || 0);
    });
  }
  // default: descending by duration (same order as percent within a bar)
  return sorted.sort(function (a, b) {
    return (b.duration || 0) - (a.duration || 0);
  });
};